import { Icon } from '@chakra-ui/react';

export const ChevronUpIcon = (props: any) => (
  <Icon aria-label="chevron up icon" {...props}>
    <path d="m12 10 3.5 4h-7z" fill="currentColor" />
  </Icon>
);
